import { render, staticRenderFns } from "./tab_highlight_post.vue?vue&type=template&id=559f2530&scoped=true&"
import script from "./tab_highlight_post.vue?vue&type=script&lang=js&"
export * from "./tab_highlight_post.vue?vue&type=script&lang=js&"
import style0 from "./tab_highlight_post.vue?vue&type=style&index=0&id=559f2530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f2530",
  null
  
)

export default component.exports